import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MenuItem, MessageService } from 'primeng/api';
import { ActiveDirectoryService } from 'src/app/private/services/activedirectoryconfig.service';
import { SharedModule } from 'src/app/private/shared/shared.module';
import { CreateActiveDirectoryComponent } from "../create-active-directory/create-active-directory.component";
import { DeleteActiveDirectoryConfigComponent } from "../delete-active-directory-config/delete-active-directory-config.component";

@Component({
  selector: 'app-active-directory-config-details',
  imports: [SharedModule, CreateActiveDirectoryComponent, DeleteActiveDirectoryConfigComponent],
  templateUrl: './active-directory-config-details.component.html',
  styleUrl: './active-directory-config-details.component.scss'
})
export class ActiveDirectoryConfigDetailsComponent {
  @Input() clientId!: string;
  tokens: any[] = [];
  totalRecords = 0;
  rows = 10;
  loading = true;

  displayAddModal = false;
  showEditModal = false;
  showDeleteModal = false;
  tokenDataToEdit: any = null;

  actionMenuItems: MenuItem[] = [
    {
      label: 'Options',
      items: [
        {
          label: 'Edit Config',
          icon: 'pi pi-pencil',
          command: () => {
            this.showEditModal = true;
          },
        },
        {
          label: 'Delete Config',
          icon: 'pi pi-trash',
          styleClass: 'delete-menu-item',
          command: () => {
            this.showDeleteModal = true;
          },
        },
      ],
    },
  ];

  constructor(private activeDirectoryService: ActiveDirectoryService) { }

  ngOnInit(): void {
    this.loadTokens();
  }

  openAddModal() {
    this.displayAddModal = true;
  }

  closeAddModal() {
    this.displayAddModal = false;
  }

  setTokenData(data: any) {
    this.tokenDataToEdit = data;
  }

  loadTokens() {
    this.loading = true;
    const payload = {
      client_id: this.clientId,
    };

    this.activeDirectoryService.getActiveDirectoryConfig(payload).subscribe({
      next: (res) => {
        this.tokens = [res|| []];
        this.totalRecords = this.tokens.length || 0;
        this.loading = false;
      },
      error: () => {
        this.tokens = [];
        this.totalRecords = 0;
        this.loading = false;
      },
    });
  }

  reload() {
    this.loadTokens();
  }
}
